import React from 'react';
import styles from '../BranchDrawer.module.css';
import Ico from '../../common/Ico';
import JsonTree from '../../common/JsonTree';
import { timeSinceTS } from '../../../helpers/dates';
import { ICO_ALERT } from './constants';
import { formatDuration } from './helpers';

export default function TaskDetailView({ task }) {
  const meta = [
    { label: 'Started',   value: task.started_at   ? timeSinceTS(task.started_at)   : '—', mono: false },
    { label: 'Completed', value: task.completed_at  ? timeSinceTS(task.completed_at) : '—', mono: false },
    { label: 'Duration',  value: formatDuration(task.started_at, task.completed_at),         mono: true  },
    { label: 'Task ID',   value: task.task_id,                                                 mono: true  },
  ];

  return (
    <>
      <div className={styles.metaGrid}>
        {meta.map((m) => (
          <div key={m.label} className={styles.metaTile}>
            <div className={styles.metaLabel}>{m.label}</div>
            <div className={`${styles.metaValue} ${m.mono ? styles.metaMono : ''}`}>{m.value}</div>
          </div>
        ))}
      </div>

      {task.error && (
        <div className={styles.errorPanel}>
          <div className={styles.errorTitle}>
            <Ico d={ICO_ALERT} size={13} />Error
          </div>
          <code className={styles.errorCode}>{task.error}</code>
        </div>
      )}

      <div>
        <div className={styles.overline}>Parameters</div>
        <div className={styles.jsonBox}>
          <JsonTree data={task.parameters} maxHeight={260} />
        </div>
      </div>

      <div>
        <div className={styles.overline}>Result</div>
        <div className={styles.jsonBox}>
          <JsonTree data={task.result} maxHeight={300} />
        </div>
      </div>
    </>
  );
}
